import {
    BankNote,
    BankNoteX
} from "../../icons";

interface SalesAbandonedMetricsProps {
    summary?: {
        valorTotal: number;
        totalAbandonos: number;
    };
    isLoading?: boolean;
}

export default function SalesAbandonedMetrics({ summary, isLoading = false }: SalesAbandonedMetricsProps) {
    // Formatação de valores numéricos para exibição
    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    };

    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
            {/* <!-- Metric Item Start --> */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                        <BankNoteX className="text-gray-800 size-6 dark:text-white/90" />
                    </div>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Total de abandonos
                    </span>
                </div>
                <div className="flex items-end justify-between mt-4">
                    <div>
                        <h4 className="mt-2 me-1 font-bold text-gray-800 text-xl dark:text-white/90 whitespace-nowrap">
                            {isLoading ? (
                                <div className="h-7 w-16 bg-gray-200 animate-pulse rounded dark:bg-gray-700"></div>
                            ) : (
                                summary?.totalAbandonos || 0
                            )}
                        </h4>
                    </div>
                </div>
            </div>
            {/* <!-- Metric Item End --> */}

            {/* <!-- Metric Item Start --> */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                        <BankNote className="text-gray-800 size-6 dark:text-white/90" />
                    </div>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Valor total
                    </span>
                </div>
                <div className="flex items-end justify-between mt-4">
                    <div>
                        <h4 className="mt-2 me-1 font-bold text-gray-800 text-xl dark:text-white/90 whitespace-nowrap">
                            {isLoading ? (
                                <div className="h-7 w-28 bg-gray-200 animate-pulse rounded dark:bg-gray-700"></div>
                            ) : (
                                formatCurrency(summary?.valorTotal || 0)
                            )}
                        </h4>
                    </div>
                </div>
            </div>
            {/* <!-- Metric Item End --> */}
        </div>
    );
}